import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/pastoral-care-banner.png';
import '../styles/pages.css';

function PastoralCare() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Pastoral Care</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Compassionate spiritual support for patients, families, and 
                            <br/>
                            staff, fostering well-being during illness and recovery.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Compassionate spiritual support for patients, families, and staff, fostering well-being during illness and recovery.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>Pastoral Care at Caritas Matha Hospital provides compassionate support and spiritual guidance to patients, families, and staff. Our dedicated team of chaplains offers comforting presence, prayer, and emotional support, respecting diverse beliefs and values. We are committed to nurturing well-being and providing solace during illness and recovery.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Supporting Your Faith, Enhancing Your Healing <br />
                        at Caritas Matha Hospital
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>The pastoral care and medical social work department at Caritas Matha Hospital functions as an essential component of our healthcare team, focusing on providing spiritual, psychological, and emotional support to patients and their families. This department plays a crucial role in the holistic health approach of the hospital, catering to individuals of all backgrounds, creeds, and religions. Our dedicated team builds strong relationships with patients through regular visits, aiming to address their spiritual and emotional needs effectively.</p>
                        <br />
                        
                        <div className='pastoral-contents'>
                            <div className='content-1'>
                                <h5>Sacraments and Spiritual Support : </h5>
                                <br />
                                <ul>
                                    <li><p>Provision of sacraments such as confession, holy eucharist, and anointing of the sick.</p></li>
                                    <br />

                                    <li><p>Spiritual guidance and support tailored to individual beliefs and practices.</p></li>
                                    <br />
                                </ul>
                            </div>
                            <div className='content-2'>
                                <h5>Counselling Services : </h5>
                                <br />
                                <ul>
                                    <li><p>Counselling sessions for patients, family members, and hospital staff.</p></li>
                                    <br />

                                    <li><p>Emotional and psychological support during times of illness or distress.</p></li>
                                    <br />
                                </ul>
                            </div>
                            <div className='content-3'>
                                <h5>Prayer Services and Community Engagement: </h5>
                                <br />
                                <ul>
                                    <li><p>Regular prayer services to promote spiritual well-being.</p></li>
                                    <br />

                                    <li><p>Activities that foster a sense of community and unity among hospital staff, including birthday celebrations and other events.</p></li>
                                    <br />
                                </ul>
                            </div>
                            <div className='content-4'>
                                <h5>Specialized Support : </h5>
                                <br />
                                <ul>
                                    <li><p>Dedicated counseling programs for patients dealing with alcoholism and substance abuse.</p></li>
                                    <br />

                                    <li><p>Psycho-social and moral support for all service users, enhancing overall well-being.</p></li>
                                    <br />
                                </ul>
                            </div>
                            <div className='content-5'>
                                <h5>Administrative Assistance : </h5>
                                <br />
                                <ul>
                                    <li><p>Coordination with hospital administration to provide financial assistance and other specific needs.</p></li>
                                    <br />

                                    <li><p>Support services to ensure comprehensive care and comfort for patients and their families.</p></li>
                                    <br />
                                </ul>
                            </div>

                            <div className='content-6'>
                                <h5>Training and Education : </h5>
                                <br />
                                <ul>
                                    <li><p>Training programs for social work interns, focusing on professional development and skills enhancement.</p></li>
                                    <br />

                                    <li><p>Educational initiatives under the LIFE program aimed at enriching the lives of patients through knowledge and empowerment.</p></li>
                                    <br />
                                </ul>
                            </div>
                        </div>

                        <br />
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default PastoralCare;